
  // Preserve Meta (fbclid), Google Ads (gclid) & UTM campaign parameters across the entire session
  (function cacheAdClickIds() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const fbclid = urlParams.get('fbclid');
      const gclid = urlParams.get('gclid');
      const utmCamp = urlParams.get('utm_campaign') || urlParams.get('campaign');
      const utmSrc = urlParams.get('utm_source');
      const utmMed = urlParams.get('utm_medium');
      if (fbclid) sessionStorage.setItem('bf_fbclid', fbclid);
      if (gclid) sessionStorage.setItem('bf_gclid', gclid);
      if (utmCamp) sessionStorage.setItem('bf_utm_campaign', utmCamp);
      if (utmSrc) sessionStorage.setItem('bf_utm_source', utmSrc);
      if (utmMed) sessionStorage.setItem('bf_utm_medium', utmMed);

      // Write 1st-party cookies (30 days expiry) so PHP server-side redirects inherit attribution
      const cookieMaxAge = 2592000;
      if (utmSrc) document.cookie = 'bf_utm_source=' + encodeURIComponent(utmSrc) + '; path=/; max-age=' + cookieMaxAge + '; SameSite=Lax';
      if (utmCamp) document.cookie = 'bf_utm_campaign=' + encodeURIComponent(utmCamp) + '; path=/; max-age=' + cookieMaxAge + '; SameSite=Lax';
      if (utmMed) document.cookie = 'bf_utm_medium=' + encodeURIComponent(utmMed) + '; path=/; max-age=' + cookieMaxAge + '; SameSite=Lax';
      if (gclid) document.cookie = 'bf_gclid=' + encodeURIComponent(gclid) + '; path=/; max-age=' + cookieMaxAge + '; SameSite=Lax';
      if (fbclid) document.cookie = 'bf_fbclid=' + encodeURIComponent(fbclid) + '; path=/; max-age=' + cookieMaxAge + '; SameSite=Lax';
    } catch (e) {}
  })();
/**
 * File: ga-tracking.js (BudgetFitter Universal Telemetry Engine)
 * Purpose: Omnichannel Event Telemetry & Analytics Dispatcher
 *
 * Universal Multi-Destination Fanout:
 *   1. Google Tag Manager / Web Analytics DataLayer (window.dataLayer)
 *   2. Google Analytics 4 Native (window.gtag)
 *   3. Cloudflare Zaraz Edge Proxy (window.zaraz.track)
 *   4. Microsoft Clarity Heatmaps & Session Replay (window.clarity + smart session tags)
 *   5. PostHog Product Analytics & Funnels (window.posthog.capture)
 *   6. Microsoft Bing Ads UET (window.uetq)
 *   7. Meta Pixel (window.fbq) & Reddit Pixel (window.rdt) auto-mapping
 *   8. Native DOM CustomEvent broadcast ('bf:telemetry')
 *
 * VERSION: 4.0 (Universal Omnichannel Telemetry Standard)
 */
(function () {
  'use strict';

  const startTime = Date.now();

  /**
   * Helper: Extracts rich page context from DOM and localized runtime variables.
   */
  function getPageContext() {
    const vars = window.bfwtVars || {};
    let postType = vars.postType || '';
    let postId = vars.postId ? String(vars.postId) : '';
    let postTitle = vars.postTitle || '';

    const body = document.body;
    if (!postType && body) {
      if (body.classList.contains('single-brand')) {
        postType = 'brand';
      } else if (body.classList.contains('single-post')) {
        postType = 'post';
      } else if (body.classList.contains('single-review') || (window.location.pathname.startsWith('/guides/') || window.location.pathname.startsWith('/review/'))) {
        postType = 'review';
      } else if (body.classList.contains('home') || body.classList.contains('front-page')) {
        postType = 'home';
      } else if (body.classList.contains('search')) {
        postType = 'search';
      } else if (body.classList.contains('archive')) {
        postType = 'archive';
      } else {
        postType = 'page';
      }
    }

    if (!postId) {
      const el = document.querySelector('article[id*="post-"], [data-post-id], #bfwt-brand-single');
      if (el) {
        postId = el.dataset.postId || el.dataset.postid || (el.id.match(/\d+/) || [''])[0];
      }
    }

    if (!postTitle) {
      const h1 = document.querySelector('h1');
      postTitle = (h1?.textContent || document.title || '').trim().replace(/\s+/g, ' ').slice(0, 100);
    }

    return {
      page_post_id: postId || '',
      page_post_type: postType || '',
      page_post_title: postTitle || '',
      page_path: window.location.pathname,
    };
  }

  /**
   * Helper: Safely parses URL parameters.
   */
  function getUrlParam(name) {
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(name) || '';
    } catch {
      return '';
    }
  }

  /**
   * Primary Omnichannel Telemetry Dispatcher.
   * NEVER early returns. Fans out to all available analytics platforms in parallel.
   */
  function dispatchTelemetryEvent(eventName, rawParams) {
    if (!eventName) {
      return;
    }

    // Single session deduplication for gate_view
    if (eventName === 'gate_view') {
      try {
        if (sessionStorage.getItem('bf_gate_view_tracked')) {
          return;
        }
        sessionStorage.setItem('bf_gate_view_tracked', '1');
      } catch {}
    }

    const context = getPageContext();
    const params = Object.assign({}, context, rawParams || {});

    // Prune undefined and null values
    for (const key of Object.keys(params)) {
      if (params[key] === undefined || params[key] === null) {
        delete params[key];
      }
    }

    // Optional console logging in debug mode
    const isDebug =
      window.bfwt_debug ||
      window.bf_debug ||
      (window.location.search && window.location.search.includes('debug_telemetry'));
    if (isDebug) {
      console.log(
        '%c[BF Telemetry] ' + eventName,
        'background:#04875d;color:#fff;font-weight:bold;padding:2px 8px;border-radius:4px;',
        params
      );
    }

    // 1. GTM / Web DataLayer
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params));
    } catch {}

    // 2. Google Analytics 4 (Native gtag)
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
      }
    } catch {}

    // 3. Cloudflare Zaraz Edge Proxy (Peer recipient, NO early return!)
    try {
      if (window.zaraz && typeof window.zaraz.track === 'function') {
        window.zaraz.track(eventName, params);
      }
    } catch {}

    // 4. Microsoft Clarity (Heatmaps + Smart Session Filtering)
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        if (params.brand_slug || params.brand_name) {
          window.clarity('set', 'brand', String(params.brand_slug || params.brand_name));
        }
        if (params.deal_id && params.deal_id !== 'direct' && params.deal_id !== 'unknown') {
          window.clarity('set', 'deal_id', String(params.deal_id));
        }
        if (params.bf_click_id) {
          window.clarity('set', 'bf_click_id', String(params.bf_click_id));
        }
        if (eventName === 'sign_up') {
          window.clarity('set', 'is_member', 'true');
          window.clarity('set', 'signup_trigger', String(params.signup_trigger || 'direct'));
        }
        if (eventName === 'affiliate_click') {
          window.clarity('set', 'converted_affiliate', 'true');
          if (params.network) {
            window.clarity('set', 'affiliate_network', String(params.network));
          }
        }
        if (eventName === 'deal_modal_open') {
          window.clarity('set', 'viewed_deal_modal', 'true');
        }
        if (eventName === 'coupon_copy') {
          window.clarity('set', 'copied_coupon', 'true');
        }
        if (eventName === 'calendar_reminder_set') {
          window.clarity('set', 'set_reminder', 'true');
        }
        if (eventName === 'gate_unlock') {
          window.clarity('set', 'lead_unlocked', 'true');
        }
        if (params.placement) {
          window.clarity('set', 'last_placement', String(params.placement));
        }
      }
    } catch {}

    // 5. PostHog (Product Analytics & Funnels)
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, params);
      }
    } catch {}

    // 6. Microsoft Bing Ads UET
    try {
      if (window.uetq && typeof window.uetq.push === 'function') {
        window.uetq.push('event', eventName, params);
      }
    } catch {}

    // 7. Meta Pixel Auto-Mapping
    try {
      if (typeof window.fbq === 'function') {
        if (eventName === 'affiliate_click') {
          window.fbq('trackCustom', 'AffiliateClick', params);
        } else if (eventName === 'coupon_copy') {
          window.fbq('trackCustom', 'CouponCopy', params);
        } else if (eventName === 'gate_unlock' || eventName === 'newsletter_signup') {
          window.fbq('track', 'Lead', { content_name: params.page_post_title || params.brand_name || 'Newsletter' });
        } else if (eventName === 'sign_up') {
          window.fbq('track', 'CompleteRegistration', {
            content_name: params.signup_trigger || 'general',
            status: true,
          });
        } else if (eventName === 'ally_proof_submit') {
          window.fbq('trackCustom', 'AllyProofSubmit', params);
          window.fbq('track', 'SubmitApplication', {
            content_name: params.brand_name || 'Ally Reward',
            value: params.order_amount || 0,
            currency: 'GBP',
          });
        } else if (eventName === 'coupon_copy') {
          window.fbq('trackCustom', 'CouponCopy', params);
        } else {
          window.fbq('trackCustom', eventName, params);
        }
      }
    } catch {}

    // 8. Reddit Pixel Auto-Mapping
    try {
      if (typeof window.rdt === 'function') {
        if (eventName === 'gate_unlock' || eventName === 'newsletter_signup') {
          window.rdt('track', 'Lead', params);
        } else if (eventName === 'affiliate_click') {
          window.rdt('track', 'Custom', { customEventName: 'AffiliateClick', ...params });
        } else if (eventName === 'coupon_copy') {
          window.rdt('track', 'Custom', { customEventName: 'CouponCopy', ...params });
        }
      }
    } catch {}

    // 9. Native DOM CustomEvent broadcast
    try {
      window.dispatchEvent(new CustomEvent('bf:telemetry', { detail: { event: eventName, params: params } }));
    } catch {}
  }

  // Universal Public APIs
  window.bfTrack = dispatchTelemetryEvent;
  window.bfwt_trackEvent = dispatchTelemetryEvent;
  window.sendEventViaDataLayer = dispatchTelemetryEvent;
  window.BF = window.BF || {};
  window.BF.track = dispatchTelemetryEvent;

  /**
   * Helper: Determines if an anchor element is an affiliate/monetization link.
   * Catches:
   *   - rel="sponsored"
   *   - Cloaked paths: /visit/*, /r/*, /out/*, /go/*, /deal/*
   *   - Known direct affiliate network hosts (Impact, Awin, CJ, Skimlinks, etc.)
   *   - Elements with data-dealid, data-ctalink, or inside deal containers
   */
  function isAffiliateTarget(anchor) {
    if (!anchor || !anchor.href) {
      return false;
    }

    const rel = (anchor.getAttribute('rel') || '').toLowerCase();
    if (/\b(sponsored)\b/.test(rel)) {
      return true;
    }

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch {
      return false;
    }

    const pathname = url.pathname;
    if (/^\/(visit|r|out|go|deal)\//i.test(pathname)) {
      return true;
    }

    if (
      anchor.hasAttribute('data-dealid') ||
      anchor.hasAttribute('data-ctalink') ||
      anchor.hasAttribute('data-code') ||
      anchor.closest('[data-dealid]') ||
      anchor.closest('.bfwt-deals-container') ||
      anchor.closest('.bfwt-buying-hub')
    ) {
      return true;
    }

    const AFFILIATE_DOMAINS = [
      'sjv.io',
      'impact.com',
      'awin1.com',
      'anrdoezrs.net',
      'dpbolvw.net',
      'tkqlhce.com',
      'jdoqocy.com',
      'cj.com',
      'skimlinks.com',
      'takeads.com',
      'flexoffers.com',
      'partnerstack.com',
      'tradedoubler.com',
      'webgains.io',
      'rakuten.com',
      'linksynergy.com',
      'topcashback.co.uk',
    ];

    return AFFILIATE_DOMAINS.some((domain) => url.hostname.endsWith(domain));
  }

  /**
   * Helper: Extracts comprehensive commercial metadata from an affiliate link/container.
   */
  function extractAffiliatePayload(anchor) {
    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch {
      url = { pathname: '', hostname: '', href: anchor.href };
    }

    const dealRow = anchor.closest('.bfwt-deal-row-inner, [data-dealid], .bfwt-buying-hub__option, article[data-deal-type]');

    // 1. Brand extraction
    let brandSlug =
      anchor.dataset.brandSlug ||
      dealRow?.dataset?.brandSlug ||
      dealRow?.dataset?.brand_slug ||
      '';
    let brandName =
      anchor.dataset.brandName ||
      dealRow?.dataset?.brandName ||
      dealRow?.dataset?.brand_name ||
      '';

    if (!brandSlug && url.pathname) {
      const visitMatch = url.pathname.match(/^\/visit\/([^/?#]+)/i);
      if (visitMatch) {
        brandSlug = visitMatch[1];
      }
    }

    if (!brandSlug) {
      const pageBrandEl = document.querySelector('[data-brand-slug], [data-brand-name], #bfwt-brand-single');
      if (pageBrandEl) {
        brandSlug = pageBrandEl.dataset.brandSlug || pageBrandEl.dataset.brand_slug || '';
        brandName = brandName || pageBrandEl.dataset.brandName || pageBrandEl.dataset.brand_name || '';
      }
    }

    if (!brandName && brandSlug) {
      brandName = brandSlug
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    }

    // 2. Deal ID
    let dealId =
      anchor.dataset.dealid ||
      anchor.dataset.dealId ||
      dealRow?.dataset?.dealid ||
      dealRow?.dataset?.dealId ||
      '';
    if (!dealId && url.pathname) {
      const outMatch = url.pathname.match(/^\/out\/(\d+)/i);
      if (outMatch) {
        dealId = outMatch[1];
      }
    }
    if (!dealId) {
      dealId = getUrlParam('deal') || 'direct';
    }

    // 3. Deal Title / Short Title
    const dealTitle =
      anchor.dataset.shorttitle ||
      dealRow?.dataset?.shorttitle ||
      dealRow?.querySelector('.bfwt-deal-title, h3, h4')?.textContent?.trim() ||
      anchor.textContent?.trim().slice(0, 80) ||
      '';

    // 4. Promo / Coupon Code
    const couponCode =
      anchor.dataset.code ||
      anchor.dataset.promo ||
      dealRow?.dataset?.code ||
      dealRow?.dataset?.promo ||
      dealRow?.querySelector('.bfwt-code-revealed, [data-code]')?.textContent?.trim() ||
      '';

    // 5. Discount Estimation
    let discount = '';
    const discountMatch = (dealTitle + ' ' + (anchor.textContent || '')).match(
      /\b(\d+%\s*(?:OFF|off)?|£\d+(?:\.\d+)?\s*(?:OFF|off)?|\$\d+(?:\.\d+)?\s*(?:OFF|off)?)\b/
    );
    if (discountMatch) {
      discount = discountMatch[1].trim().toUpperCase();
    }

    // 6. Network Detection
    let network = dealRow?.dataset?.network || '';
    if (!network) {
      const host = url.hostname.toLowerCase();
      if (host.includes('sjv.io') || host.includes('impact.com')) {
        network = 'impact';
      } else if (host.includes('awin1.com')) {
        network = 'awin';
      } else if (
        host.includes('anrdoezrs.net') ||
        host.includes('dpbolvw.net') ||
        host.includes('tkqlhce.com') ||
        host.includes('jdoqocy.com') ||
        host.includes('cj.com')
      ) {
        network = 'cj';
      } else if (host.includes('skimlinks.com')) {
        network = 'skimlinks';
      } else if (host.includes('takeads.com')) {
        network = 'takeads';
      } else if (host.includes('flexoffers.com')) {
        network = 'flexoffers';
      } else if (host.includes('partnerstack.com')) {
        network = 'partnerstack';
      } else if (host.includes('topcashback.co.uk')) {
        network = 'topcashback';
      } else if (/^\/(visit|r|out|go)\//i.test(url.pathname)) {
        network = 'cloaked_redirect';
      } else {
        network = 'direct_merchant';
      }
    }

    // 7. Placement Surface
    let placement = 'editorial_inline';
    if (anchor.closest('.bfwt-buying-hub, [class*="buying-hub"]')) {
      placement = 'buying_hub';
    } else if (anchor.closest('.bfwt-brand-header')) {
      placement = 'brand_header';
    } else if (anchor.closest('.bfwt-popup-overlay, .bfwt-coupon-stacked-modal')) {
      placement = 'coupon_popup';
    } else if (anchor.closest('.bfwt-featured-deal, .bfwt-hero-deal')) {
      placement = 'featured_banner';
    } else if (anchor.closest('.bfwt-deals-container')) {
      placement = 'deals_feed';
    } else if (anchor.closest('#secondary, .sidebar, [class*="sidebar"]')) {
      placement = 'sidebar';
    } else if (anchor.closest('.bf-gate-overlay, #bf-content-gate-form')) {
      placement = 'content_gate';
    }

    // 8. Deal Type
    const dealType = couponCode ? 'voucher' : dealRow?.dataset?.dealType || 'deal';

    return {
      brand_slug: brandSlug,
      brand_name: brandName,
      deal_id: dealId,
      deal_title: dealTitle,
      deal_type: dealType,
      coupon_code: couponCode,
      discount: discount,
      network: network,
      placement: placement,
      outbound_url: anchor.href,
      event_category: 'monetization',
    };
  }

  /**
   * Main Delegated Click Listener for Interactions Across BudgetFitter
   */
  document.addEventListener('click', function (event) {
    const target = event.target;

    // -------------------------------------------------------------
    // 1. Coupon Copy / Reveal Actions
    // -------------------------------------------------------------
    const copyTarget = target.closest(
      '.bfwt-code-container, .bfwt-code-revealed, [data-code], .bfwt-copy-code-btn, .bfwt-ticket-coupon, a[onclick*="bfHandleHubCTA"]'
    );
    if (copyTarget) {
      const code =
        copyTarget.dataset.code ||
        copyTarget.dataset.promo ||
        copyTarget.closest('[data-code]')?.dataset?.code ||
        copyTarget.textContent?.trim() ||
        '';

      if (code) {
        const payload = extractAffiliatePayload(copyTarget.closest('a') || copyTarget);
        payload.coupon_code = code;
        dispatchTelemetryEvent('coupon_copy', payload);
      }
    }

    // -------------------------------------------------------------
    // 2. Affiliate & Commercial Outbound Clicks
    // -------------------------------------------------------------
    const affiliateLink = target.closest('a[href]');
    if (affiliateLink && isAffiliateTarget(affiliateLink)) {
      const payload = extractAffiliatePayload(affiliateLink);

      // Primary universal event
      dispatchTelemetryEvent('affiliate_click', payload);

      // Backward compatibility aliases for existing custom GA4 dashboards
      if (affiliateLink.closest('.bfwt-code-container')) {
        dispatchTelemetryEvent('copy_continue_click', {
          event_category: 'bf_deals',
          event_label: 'Copy & Continue Button',
          deal_id: payload.deal_id,
          brand_slug: payload.brand_slug,
        });
      } else if (affiliateLink.closest('.bfwt-cta-button')) {
        dispatchTelemetryEvent('cta_button_click', {
          event_category: 'bf_deals',
          event_label: payload.deal_title || 'CTA Button',
          deal_id: payload.deal_id,
          brand_slug: payload.brand_slug,
        });
      } else if (affiliateLink.closest('.bfwt-popup-cta')) {
        dispatchTelemetryEvent('continue_website_click', {
          event_category: 'bf_deals',
          event_label: 'Continue to Website Button (Popup)',
          deal_id: payload.deal_id,
          brand_slug: payload.brand_slug,
        });
      }

      return;
    }

    // -------------------------------------------------------------
    // 3. Table of Contents Jumps
    // -------------------------------------------------------------
    const tocLink = target.closest('.bfwt-toc a[href^="#"], [data-toc] a[href^="#"], .bfwt-toc-list a[href^="#"]');
    if (tocLink) {
      const headingId = tocLink.getAttribute('href') || '';
      dispatchTelemetryEvent('toc_click', {
        heading_id: headingId,
        heading_title: tocLink.textContent?.trim().slice(0, 80) || '',
        event_category: 'navigation',
      });
      return;
    }

    // -------------------------------------------------------------
    // 4. Archive Grid Cards (Brand / Review / Quiz / Guide)
    // -------------------------------------------------------------
    const cardLink = target.closest('.bfwt-card a[href], .bfwt-archive-grid a.bfwt-card');
    if (cardLink) {
      const card = cardLink.closest('.bfwt-card') || cardLink;
      let contentType = card.dataset?.contentType;
      if (!contentType) {
        if (card.classList.contains('bfwt-card--brand')) {
          contentType = 'brand';
        } else if (card.classList.contains('bfwt-card--post') || card.closest('.bfwt-posts-grid')) {
          contentType = 'post';
        } else if (card.closest('[data-post-id]') && card.getAttribute('href')?.includes('/quizzes/')) {
          contentType = 'quiz';
        } else {
          contentType = 'link';
        }
      }
      const contentId = card.dataset?.postId || card.closest('[data-post-id]')?.dataset?.postId || '';
      const cardTitle = card.querySelector('h2, h3, h4, .bfwt-card__title')?.textContent?.trim().slice(0, 80) || '';

      dispatchTelemetryEvent('card_click', {
        content_type: contentType,
        content_id: contentId,
        content_title: cardTitle,
        event_category: 'engagement',
      });
      return;
    }

    // -------------------------------------------------------------
    // 5. Single Brand Header Primary CTA
    // -------------------------------------------------------------
    const brandHeaderCta = target.closest('.bfwt-brand-header a.bf-button--primary');
    if (brandHeaderCta) {
      const brandName =
        brandHeaderCta.closest('[data-brand-name]')?.dataset?.brandName ||
        document.querySelector('[data-brand-name]')?.dataset?.brandName ||
        '';
      const brandId =
        brandHeaderCta.closest('[data-post-id]')?.dataset?.postId ||
        document.querySelector('#bfwt-brand-single')?.dataset?.postId ||
        '';
      dispatchTelemetryEvent('brand_cta_click', {
        brand_id: brandId,
        brand_name: brandName,
        cta_type: 'insider',
        event_category: 'brand',
      });
      return;
    }

    // -------------------------------------------------------------
    // 6. Floating Sheets (Explore / Solutions / Toolkit)
    // -------------------------------------------------------------
    const sheetLink = target.closest('.bfwt-floating-sheet a[href]');
    if (sheetLink && !target.closest('.bfwt-btn-close')) {
      const sheet = sheetLink.closest('.bfwt-floating-sheet');
      const sheetId = sheet && sheet.id ? sheet.id : '';
      let linkType = 'link';
      if (sheetId === 'sheet-explore') {
        linkType = 'category';
      } else if (sheetId === 'sheet-solutions') {
        linkType = 'collection';
      } else if (sheetLink.closest('.bfwt-toolkit-card')) {
        linkType = 'toolkit_card';
      }
      dispatchTelemetryEvent('sheet_link_click', {
        sheet_id: sheetId,
        link_type: linkType,
        link_text: (sheetLink.textContent || '').trim().slice(0, 80),
        event_category: 'navigation',
      });
      return;
    }

    // -------------------------------------------------------------
    // 7. Mobile App & Browser Extension Downloads
    // -------------------------------------------------------------
    const extBtn = target.closest('.bfwt-ext-btn');
    if (extBtn && extBtn.href) {
      const href = extBtn.getAttribute('href').toLowerCase();
      const store = href.includes('chromewebstore') ? 'chrome' : href.includes('microsoftedge') ? 'edge' : null;
      if (store) {
        dispatchTelemetryEvent('extension_click', {
          store: store,
          event_category: 'conversion',
        });
      }
      return;
    }

    const appDownloadLink = target.closest(
      '.bf-custom-cta-buttons a[href*="play.google.com"], .bf-custom-cta-buttons a[href*="apps.apple.com"]'
    );
    if (appDownloadLink) {
      const href = (appDownloadLink.getAttribute('href') || '').toLowerCase();
      const store = href.includes('play.google.com') ? 'android' : href.includes('apps.apple.com') ? 'ios' : null;
      if (store) {
        dispatchTelemetryEvent('app_download_click', {
          store: store,
          page: 'mobile_app',
          event_category: 'conversion',
        });
      }
      return;
    }

    // -------------------------------------------------------------
    // 8. Pagination Links
    // -------------------------------------------------------------
    const paginationLink = target.closest('.bfwt-pagination a, .page-numbers a');
    if (paginationLink) {
      const href = paginationLink.getAttribute('href') || '';
      const match = href.match(/page\/(\d+)/) || href.match(/[?&]paged?=(\d+)/);
      const pageNumber = match ? match[1] : '';
      const isNext = paginationLink.textContent && /next|»|›/i.test(paginationLink.textContent.trim());
      const isPrev = paginationLink.textContent && /prev|«|‹/i.test(paginationLink.textContent.trim());
      dispatchTelemetryEvent('pagination_click', {
        page_number: pageNumber,
        direction: isNext ? 'next' : isPrev ? 'prev' : '',
        event_category: 'navigation',
      });
      return;
    }

    // -------------------------------------------------------------
    // 9. FAQ / Accordion Expand
    // -------------------------------------------------------------
    const accordionSummary = target.closest('details[data-accordion-item] > summary');
    if (accordionSummary) {
      const details = accordionSummary.parentElement;
      if (details && !details.open) {
        const titleNode = accordionSummary.querySelector('span') || accordionSummary;
        dispatchTelemetryEvent('expand_faq', {
          faq_title: (titleNode.innerText || '').trim().slice(0, 100),
          event_category: 'engagement',
        });
      }
      return;
    }

    // -------------------------------------------------------------
    // 10. Social & General Outbound Links
    // -------------------------------------------------------------
    const externalLink = target.closest('a[href]');
    if (externalLink) {
      let hostname = '';
      try {
        hostname = new URL(externalLink.href, window.location.origin).hostname;
      } catch {}

      if (hostname && hostname !== window.location.hostname) {
        const SOCIAL_HOSTS = {
          'twitter.com': 'x',
          'x.com': 'x',
          'instagram.com': 'instagram',
          'facebook.com': 'facebook',
          'youtube.com': 'youtube',
          'youtu.be': 'youtube',
          'tiktok.com': 'tiktok',
          'linkedin.com': 'linkedin',
          'pinterest.com': 'pinterest',
          'reddit.com': 'reddit',
        };
        const socialNet = SOCIAL_HOSTS[hostname.replace(/^www\./, '')];
        if (socialNet) {
          dispatchTelemetryEvent('social_click', {
            network: socialNet,
            href: externalLink.href,
            event_category: 'engagement',
          });
        } else {
          dispatchTelemetryEvent('external_outbound', {
            host: hostname,
            href: externalLink.href,
            event_category: 'engagement',
          });
        }
      }
    }
  });

  // -------------------------------------------------------------
  // Filter Bar PJAX & Sort Listeners
  // -------------------------------------------------------------
  document.addEventListener('click', function (event) {
    const filterToggle = event.target.closest('.bfwt-filter-bar__toggle');
    if (filterToggle) {
      const bar = filterToggle.closest('.bfwt-filter-bar');
      const wasActive = filterToggle.classList.contains('is-active');
      dispatchTelemetryEvent('filter_applied', {
        filter_bar_id: bar?.id || '',
        filter_type: 'toggle',
        filter_label: (filterToggle.innerText || '').trim().slice(0, 60),
        action: wasActive ? 'remove' : 'add',
        event_category: 'navigation',
      });
      return;
    }

    const filterReset = event.target.closest('.bfwt-filter-bar__reset');
    if (filterReset) {
      const bar = filterReset.closest('.bfwt-filter-bar');
      dispatchTelemetryEvent('filter_applied', {
        filter_bar_id: bar?.id || '',
        filter_type: 'reset',
        event_category: 'navigation',
      });
      return;
    }

    const viewBtn = event.target.closest('.bfwt-filter-bar__view-btn');
    if (viewBtn) {
      const bar = viewBtn.closest('.bfwt-filter-bar');
      dispatchTelemetryEvent('filter_applied', {
        filter_bar_id: bar?.id || '',
        filter_type: 'view_mode',
        view: viewBtn.dataset.view || '',
        event_category: 'navigation',
      });
      return;
    }

    const searchFilterChip = event.target.closest('[data-search-filters] [data-search-filter]');
    if (searchFilterChip) {
      dispatchTelemetryEvent('search_filter', {
        filter_type: searchFilterChip.dataset.searchFilter || 'all',
        event_category: 'engagement',
      });
    }
  });

  document.addEventListener(
    'change',
    function (event) {
      const sortSelect = event.target.closest('.bfwt-filter-bar select[data-pjax-sort]');
      if (sortSelect) {
        const bar = sortSelect.closest('.bfwt-filter-bar');
        const opt = sortSelect.options[sortSelect.selectedIndex];
        dispatchTelemetryEvent('filter_applied', {
          filter_bar_id: bar?.id || '',
          filter_type: 'sort',
          sort_value: opt?.text || '',
          event_category: 'navigation',
        });
      }
    },
    true
  );

  // -------------------------------------------------------------
  // Form Submits: Comments & Search
  // -------------------------------------------------------------
  document.addEventListener(
    'submit',
    function (event) {
      const commentForm = event.target.closest('#commentform');
      if (commentForm) {
        const postIdInput = commentForm.querySelector('input[name="comment_post_ID"]');
        dispatchTelemetryEvent('comment_submit', {
          post_id: postIdInput?.value || '',
          event_category: 'engagement',
        });
      }
    },
    true
  );

  // Page load search event (guarded for head execution)
  function checkPageLoadSearch() {
    if (document.body && (document.body.classList.contains('search') || document.body.classList.contains('search-results'))) {
      const params = new URLSearchParams(window.location.search);
      dispatchTelemetryEvent('search_query', {
        search_term: params.get('s') || '',
        filter_type: params.get('post_type') || 'all',
        event_category: 'engagement',
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkPageLoadSearch);
  } else {
    checkPageLoadSearch();
  }

  // -------------------------------------------------------------
  // Content Gate Telemetry (View & Unlock Listeners)
  // -------------------------------------------------------------
  (function initGateTelemetry() {
    let viewTracked = false;

    function triggerGateView(detail) {
      if (viewTracked) {
        return;
      }
      try {
        if (sessionStorage.getItem('bf_gate_view_tracked')) {
          viewTracked = true;
          return;
        }
        sessionStorage.setItem('bf_gate_view_tracked', '1');
      } catch {}

      viewTracked = true;
      const searchParams = new URLSearchParams(window.location.search);
      dispatchTelemetryEvent('gate_view', {
        gate_style: 'editorial',
        utm_source: detail?.utm_source || searchParams.get('utm_source') || '',
        utm_medium: detail?.utm_medium || searchParams.get('utm_medium') || '',
        utm_campaign: detail?.utm_campaign || searchParams.get('utm_campaign') || '',
        event_category: 'conversion',
      });
    }

    function checkGateInDOM() {
      if (viewTracked) {
        return;
      }
      const isAlreadyUnlocked =
        (document.body && document.body.classList.contains('bf-gate-unlocked')) ||
        (typeof localStorage !== 'undefined' && localStorage.getItem('bf_gate_unlocked') === '1');

      if (isAlreadyUnlocked) {
        return;
      }

      const gateEl =
        document.getElementById('bf-editorial-paywall') ||
        document.getElementById('bf-paywall-card') ||
        document.getElementById('bf-gate-email-form') ||
        document.querySelector('.bf-editorial-paywall, .bf-gate-overlay');

      if (gateEl) {
        triggerGateView({});
      }
    }

    checkGateInDOM();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', checkGateInDOM);
    }

    if (typeof MutationObserver !== 'undefined' && document.documentElement) {
      const observer = new MutationObserver(function () {
        if (viewTracked) {
          observer.disconnect();
          return;
        }
        checkGateInDOM();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        observer.disconnect();
      }, 8000);
    }

    window.addEventListener('bf:gate_view', function (e) {
      triggerGateView(e.detail || {});
    });

    window.addEventListener('bf:gate_unlock', function (e) {
      const detail = e.detail || {};
      dispatchTelemetryEvent('gate_unlock', {
        method: detail.method || 'email',
        email_domain: detail.email ? detail.email.split('@')[1] : '',
        utm_source: detail.utm_source || getUrlParam('utm_source'),
        utm_medium: detail.utm_medium || getUrlParam('utm_medium'),
        utm_campaign: detail.utm_campaign || getUrlParam('utm_campaign'),
        event_category: 'conversion',
      });
    });
  })();

  // -------------------------------------------------------------
  // Substantive Content Reading Milestones (25%, 50%, 75%, 100%)
  // Monitors .bfwt-prose-content or main article container
  // -------------------------------------------------------------
  (function initReadingMilestones() {
    const thresholds = [25, 50, 75, 100];
    const fired = new Set();
    let ticking = false;

    function checkMilestones() {
      ticking = false;
      const contentEl =
        document.querySelector('.bfwt-prose-content') ||
        document.querySelector('article.bfwt-single-post') ||
        document.querySelector('.entry-content');

      if (!contentEl) {
        return;
      }

      const rect = contentEl.getBoundingClientRect();
      const contentHeight = rect.height;
      if (contentHeight < 300) {
        return;
      }

      // Mathematically exact article reading progress (0% to 100%)
      const articleTop = window.scrollY + rect.top;
      const visibleBottom = window.scrollY + window.innerHeight;
      const scrolled = visibleBottom - articleTop;
      const percent = Math.min(100, Math.max(0, Math.round((scrolled / contentHeight) * 100)));

      const timeElapsed = Math.round((Date.now() - startTime) / 1000);

      for (const t of thresholds) {
        if (percent >= t && !fired.has(t)) {
          fired.add(t);
          dispatchTelemetryEvent('reading_milestone', {
            milestone_percent: t,
            time_on_page_sec: timeElapsed,
            event_category: 'engagement',
          });
        }
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) {
          return;
        }
        ticking = true;
        requestAnimationFrame(checkMilestones);
      },
      { passive: true }
    );
  })();
})();
